export interface localInfoType {
    currencyCode: string;
    languageCode: string;
    currencySymbol: string;
    currencyName: string;
    timeZoneId: string;
}
// todo 该文件用于定义基本请求/响应的Vo、页码Vo
export interface Response<T> {
    code: number | string;
    data: T;
    msg: string;
    traceId: string;
    success: boolean;
    localInfo?: localInfoType;
}
// todo 该文件用户请求数据是 to 的返回值的类型
export type RequestTo<T> = Promise<[null, T] | [Error, undefined]>;

// 获取 sessionId Request data;
export interface sessionProps {
    riskType: number;
    email?: string;
    mobile?: string;
    mobilePrefix?: string;
}

// 获取 sessionId Response data;
export interface sessionIdResponse {
    sessionId: string;
}

// 判断用户是 新老用户 Request data；
export interface NewOrOldUserRequest {
    idPrefix: string;
    identifier: string | number;
    otpType: number;
}

// 发送验证码参数
export interface SendCodeType {
    otpType: number;
    idPrefix?: string;
    identifier: string;
    scene: number;
    appId: string;
    sessionId: string | null;
    captchaCode?: string | null;
    captchaAction?: string | null;
}

// 校验邮箱注册参数
export interface VerifyEmailRegisterParams {
    email: string;
    password: string;
    sessionId: string;
    appId: string;
    verifyCode?: string;
    captchaCode?: string | null;
    captchaAction?: string | null;
}

// 校验邮箱登录参数
export interface VerifyEmailLoginParams {
    identifier: string;
    password: string;
    sessionId: string;
    appId?: string;
    loginType: number;
    otpType: number;
    verifyCode?: string;
    captchaCode?: string | null;
    captchaAction?: string | null;
}

// 邮箱忘记密码校验验证码
export interface verifyCodeCheckRequest {
    email: string;
    optVerifyCode: string;
    otpType: number;
    scene: number;
    stepCode: string;
}

// 获取验证码 参数
export interface GetCaptchaParams {
  otpType: number;
  idPrefix: string;
  identifier: string;
  scene: number;
  appId: string;
  sessionId: string | null;
  captchaCode: string | null;
  captchaAction?: string | null;
}

// 校验手机号验证码参数
export interface VerifyCodeParams {
  otpType: number;
  idPrefix?: string;
  identifier: string;
  verifyCode: string | undefined;
  appId: string;
  sessionId: string | null;
  captchaCode: string | null;
  captchaAction?: string | null;
  stepCode?: string;
}

// 校验手机号验证码登录 response
export interface VerifyCodeResponse {}

// 第三方登录入参
export interface ThirdLoginType {
  state: string;
  loginType: string;
  code: string;
}

// 校验账户
export interface VerifyAccountRequest {
  exist: boolean;
  riskType: AccountRiskType;
}

export enum AccountRiskType {
  White = 0, // 白名单不风控
  Google = 1, // google 风控
  Joybuy = 2, // joybuy 滑块风控
}

export interface EmailSliderFn {
  onEmailSliderSuccess?: ((param?: any) => void),
  onEmailCancel?: ((param?: any) => void),
  onEmailSendSuccess?: ((param?: any) => void),
  onEmailCodeAlreadySend?: ((param?: any) => void),
  onVerifySuccess?: ((param?: any) => void)
}